export const TYPES = {
  analyticsCollector: {
    AnalyticsCollector: "AnalyticsCollector",
    GoogleAnalyticsSender: "GoogleAnalyticsSender",
    VintomAnalyticsSender: "VintomAnalyticsSender",
  },
  animationPersonalizer: {
    AnimationPersonalizer: "AnimationPersonalizer",
  },
  configurationBuilder: {
    ConfigurationBuilder: "ConfigurationBuilder",
  },
  iframeNotifier: {
    IframeNotifier: "IframeNotifier",
  },
  layer: {
    PlayerContainer: "PlayerContainer",
    AnimationLayer: "AnimationLayer",
    ControlsLayer: "ControlsLayer",
    CTALayer: "CTALayer",
    PosterLayer: "PosterLayer",
    VideoLayer: "VideoLayer",
    MusicLayer: "MusicLayer",
  },
  loader: {
    playerLoader: {
      PlayerLoader: "PlayerLoader",
    },
    resourceLoader: {
      ResourceLoader: "ResourceLoader",
    },
    scenarioLoader: {
      ScenarioLoader: "ScenarioLoader",
    },
  },
  personalizer: {
    Personalizer: "Personalizer",
  },
  preferencesStorage: {
    PreferencesStorage: "PreferencesStorage",
  },
  errorReporter: {
    ErrorReporter: "ErrorReporter",
  },
  Looper: "Looper",
  scenarioRunner: {
    layerManager: {
      PlayerContainerManager: "PlayerContainerManager",
      ControlsLayerManager: "ControlsLayerManager",
      CTALayerManager: "CTALayerManager",
      DependentAnimationLayerManager: "DependentAnimationLayerManager",
      IndependentAnimationLayerManager: "IndependentAnimationLayerManager",
      PosterLayerManager: "PosterLayerManager",
      VideoLayerManager: "VideoLayerManager",
      MusicLayerManager: "MusicLayerManager",
    },
    playbackInformation: "PlaybackInformationHandle",
    AnimationDrivenScenarioExecutor: "AnimationDrivenScenarioExecutor",
    CTAOnlyScenarioExecutor: "CTAOnlyScenarioExecutor",
    ScenarioRunner: "ScenarioRunner",
    VideoDrivenScenarioExecutor: "VideoDrivenScenarioExecutor",
  },
  music: {
    MusicManager: "MusicManager",
    MusicPlayer: "MusicPlayer",
    VolumeTransitionManager: "VolumeTransitionManager",
  },
  themeUpdater: {
    ThemeUpdater: "ThemeUpadater",
  },
  PlayerManager: "PlayerManager",
};
